// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6d0875433e0e4c1376d8","655":"7a9221125d92d6e1bb42"}[chunkId] + ".js";
};